import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-svg-search-button",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./svg-search-button.component.html",
  styleUrls: ["./svg-search-button.component.scss"]
})

export class SvgButtonComponent {
  @Input() disabled = false;
  @Input() ariaLabel = "Button";
  @Output() buttonClick = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      return;
    }
    this.buttonClick.emit(event);
  }
}